import { render, staticRenderFns } from "./CmgLeaderboardBadgesEarned.vue?vue&type=template&id=6a5c450c&scoped=true&lang=pug"
import script from "./cmg-leaderboard-badges-earned.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-badges-earned.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardBadgesEarned.vue?vue&type=style&index=0&id=6a5c450c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5c450c",
  null
  
)

export default component.exports